import React from "react";
import { makeStyles } from "@mui/styles";
import { Container, Box, Typography, Stack } from "@mui/material";
import useDate from "../hook/useDate";
import Controls from "../components/controls/Controls";
import * as textBodyMessage from "../Services/textBody";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const useStyles = makeStyles({
  time: {
    "&.MuiTypography-root": {
      fontFamily: "Rajdhani",
      fontSize: "2rem",
      color: "#777777",
      minWidth: "22%",
    },
    "& span": {
      paddingLeft: "1rem",
      fontSize: "3rem",
      color: "#AAAAAA",
    },
  },
  name: {
    "&.MuiTypography-root": {
      fontFamily: "Rajdhani",
      fontSize: "3rem",
      color: "#AAAAAA",
    },
  },
});

function Footer(props) {
  const classes = useStyles();
  const { time } = useDate();
  return (
    <Container maxWidth="lg" id="footer-container">
      <Stack
        component="div"
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        pt={8}
        pb={7}
      >
        <Typography variant="subtitle1" className={classes.time}>
          Dhaka,BD
          <span>{time}</span>
        </Typography>
        <Box component="div">
          <Controls.IconButton
            href={textBodyMessage.contact.github}
            sx={{ marginRight: "3rem" }}
          >
            <GitHubIcon />
          </Controls.IconButton>
          <Controls.IconButton href={textBodyMessage.contact.linkedIn}>
            <LinkedInIcon />
          </Controls.IconButton>
        </Box>
        <Typography variant="h6" className={classes.name}>
          &#169; Touhid Alam 2022
        </Typography>
      </Stack>
    </Container>
  );
}

export default Footer;
